module.exports = __webpack_public_path__ + "static/hero_plus-07d245dd4467492d7dc309941a172389.png";